import { render, staticRenderFns } from "./BuyerHome.vue?vue&type=template&id=64e716af&scoped=true"
import script from "./BuyerHome.vue?vue&type=script&lang=js"
export * from "./BuyerHome.vue?vue&type=script&lang=js"
import style0 from "./BuyerHome.vue?vue&type=style&index=0&id=64e716af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e716af",
  null
  
)

export default component.exports